import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';

const PanelLayout = ({ children }) => {
   // Each page mounts its own PanelLayout, so state is rebuilt on every navigation.
   // On mobile the sidebar is an overlay and always starts closed; the saved
   // preference only applies to desktop.
   const [sidebarOpen, setSidebarOpen] = useState(() => {
      if (window.innerWidth < 1024) return false;
      const saved = localStorage.getItem('panelSidebarOpen');
      return saved !== null ? saved === 'true' : true;
   });

   // Persist the desktop preference only, so mobile toggles don't overwrite it
   useEffect(() => {
      if (window.innerWidth >= 1024) {
         localStorage.setItem('panelSidebarOpen', sidebarOpen.toString());
      }
   }, [sidebarOpen]);

   const toggleSidebar = () => {
      setSidebarOpen((prev) => !prev);
   };

   return (
      <div className="min-h-screen bg-gray-100 dark:bg-dark-primary">
         {/* Mobile overlay */}
         {sidebarOpen && (
            <div
               className="fixed inset-0 z-30 bg-black bg-opacity-50 lg:hidden"
               onClick={toggleSidebar}
            />
         )}
         <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
         <div
            className={`transition-all duration-300 ${sidebarOpen ? 'lg:ml-64' : 'lg:ml-[56px]'}`}
         >
            <Header toggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen} />
            <main className="p-3 sm:p-4 lg:p-6">{children}</main>
         </div>
      </div>
   );
};

export default PanelLayout;
